import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import MyStorage from './util/storage';
import { Oval as Loader } from 'react-loader-spinner';
import { ToastContainer } from 'react-toastify';
import Api from './api/api';
import {
    epochToEasternDateKey,
    epochToEasternWallTime,
    formatEastern,
    formatEasternNow
} from './util/eastern-time';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

// Default time-of-day used when the admin adds a push by clicking a calendar day.
const DEFAULT_SLOT = '09:00';

const pad = (n) => (n < 10 ? '0' + n : '' + n);
const dateKey = (y, m, d) => `${y}-${pad(m + 1)}-${pad(d)}`;

// "HH:mm" (24h) -> "9:00 AM"
const prettyTime = (hhmm) => {
    const [h, mi] = hhmm.split(':').map(Number);
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${hour12}:${pad(mi)} ${suffix}`;
};

const statusColor = (status) => {
    if (status === 'sent') return 'green';
    if (status === 'failed') return 'red';
    return '#5c6bc0';
};

const ScheduledNotifications = () => {
    const navigate = useNavigate();
    const [models, setModels] = useState([]);
    const [loader, setLoader] = useState(false);

    // Calendar month being viewed — starts on the current Eastern month.
    const todayKey = epochToEasternDateKey(Date.now());
    const [year, setYear] = useState(Number(todayKey.split('-')[0]));
    const [month, setMonth] = useState(Number(todayKey.split('-')[1]) - 1);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setLoader(true);
        Api.getScheduledPushes(
            (response) => {
                setLoader(false);
                setModels(response);
            },
            () => {
                setLoader(false);
            }
        );
    };

    const editPush = (item) => {
        navigate('/admin/send-notification', { state: { model: item } });
    };

    const addOnDay = (key) => {
        navigate('/admin/send-notification', { state: { scheduledDateTime: `${key}T${DEFAULT_SLOT}` } });
    };

    const deletePush = (item) => {
        if (window.confirm('Delete this scheduled notification?')) {
            setModels(models.filter((m) => m.id !== item.id));
            Api.deleteScheduledPush(item.id);
        }
    };

    if (!MyStorage.isLogin()) {
        return null;
    }

    // Group pushes by their Eastern calendar day for the month grid.
    const byDay = {};
    models.forEach((m) => {
        if (!m.scheduledAt) return;
        const key = epochToEasternDateKey(m.scheduledAt);
        if (!byDay[key]) byDay[key] = [];
        byDay[key].push(m);
    });

    const firstWeekday = new Date(Date.UTC(year, month, 1)).getUTCDay();
    const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    const cells = [];
    for (let i = 0; i < firstWeekday; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);
    while (cells.length % 7 !== 0) cells.push(null);

    const changeMonth = (delta) => {
        const next = month + delta;
        if (next < 0) { setMonth(11); setYear(year - 1); }
        else if (next > 11) { setMonth(0); setYear(year + 1); }
        else setMonth(next);
    };

    const upcoming = models.filter(m => m.status !== 'sent' && m.status !== 'failed');
    const past = models.filter(m => m.status === 'sent' || m.status === 'failed')
        .sort((a, b) => b.scheduledAt - a.scheduledAt);

    const renderRow = (item) => (
        <div key={item.id} style={{ width: '100%', backgroundColor: '#f2f2f2', marginTop: 10, padding: 10, display: 'flex', alignItems: 'center' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 4 }}>{item.title}</div>
                <div style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>{item.body}</div>
                <div style={{ fontSize: 12, color: statusColor(item.status) }}>
                    {item.scheduledAt ? formatEastern(item.scheduledAt) : '—'}
                    {' · '}
                    {item.status === 'sent' ? 'Sent' : item.status === 'failed' ? `Failed${item.error ? ': ' + item.error : ''}` : 'Scheduled'}
                </div>
            </div>
            <div style={{ display: 'flex' }}>
                {item.status !== 'sent' && (
                    <Button
                        className='btn-block btn-dark'
                        style={{ fontSize: 14, marginRight: 10, backgroundColor: 'gray', borderWidth: 0, height: 36, width: 80 }}
                        onClick={() => editPush(item)}>
                        Edit
                    </Button>
                )}
                <Button
                    className='btn-block btn-dark'
                    style={{ fontSize: 14, backgroundColor: 'red', borderWidth: 0, height: 36, width: 80 }}
                    onClick={() => deletePush(item)}>
                    Delete
                </Button>
            </div>
        </div>
    );

    return (
        <div className='main' style={{ padding: 0 }}>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: 0 }}>
                <div style={{ color: 'blue' }}>Scheduled Notifications</div>
            </div>

            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
                <div style={{ padding: 20, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'scroll' }}>

                    <Button
                        className='btn-block btn-dark'
                        style={{ marginTop: 0, fontSize: 16, backgroundColor: 'green', borderWidth: 0, height: 40, width: 300, alignSelf: 'center' }}
                        onClick={() => navigate('/admin/send-notification', { state: { scheduledDateTime: epochToEasternWallTime(Date.now() + 3600000).split('T')[0] + 'T' + DEFAULT_SLOT } })}>
                        Schedule Notification
                    </Button>

                    <div style={{ fontSize: 12, color: '#5c6bc0', alignSelf: 'center', marginTop: 8 }}>
                        Current Eastern time: <strong>{formatEasternNow()}</strong>
                    </div>

                    {/* Month calendar — click any day to schedule a push on it */}
                    <div style={{ marginTop: 20, backgroundColor: 'white', padding: 10, borderRadius: 6 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                            <Button
                                className='btn-block btn-dark'
                                style={{ fontSize: 14, backgroundColor: 'gray', borderWidth: 0, height: 34, width: 100 }}
                                onClick={() => changeMonth(-1)}>
                                ‹ Prev
                            </Button>
                            <div style={{ fontSize: 18, fontWeight: 'bold' }}>{MONTHS[month]} {year}</div>
                            <Button
                                className='btn-block btn-dark'
                                style={{ fontSize: 14, backgroundColor: 'gray', borderWidth: 0, height: 34, width: 100 }}
                                onClick={() => changeMonth(1)}>
                                Next ›
                            </Button>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
                            {WEEKDAYS.map(d => (
                                <div key={d} style={{ textAlign: 'center', fontSize: 12, fontWeight: 'bold', color: '#555', padding: 4 }}>{d}</div>
                            ))}
                            {cells.map((day, i) => {
                                if (day === null) {
                                    return <div key={'e' + i} style={{ minHeight: 90, backgroundColor: '#fafafa', borderRadius: 4 }} />;
                                }
                                const key = dateKey(year, month, day);
                                const items = (byDay[key] || []).slice().sort((a, b) => a.scheduledAt - b.scheduledAt);
                                const isToday = key === todayKey;
                                const isPast = key < todayKey;
                                return (
                                    <div
                                        key={key}
                                        onClick={() => { if (!isPast) addOnDay(key); }}
                                        title={isPast ? '' : 'Click to schedule a notification on this day'}
                                        style={{
                                            minHeight: 90,
                                            padding: 4,
                                            borderRadius: 4,
                                            border: isToday ? '2px solid #5c6bc0' : '1px solid #e0e0e0',
                                            backgroundColor: isPast ? '#f7f7f7' : 'white',
                                            cursor: isPast ? 'default' : 'pointer'
                                        }}>
                                        <div style={{ fontSize: 12, fontWeight: 'bold', color: isPast ? '#aaa' : '#333', marginBottom: 4 }}>{day}</div>
                                        {items.map(item => (
                                            <div
                                                key={item.id}
                                                onClick={(e) => { e.stopPropagation(); editPush(item); }}
                                                title={`${item.title} — ${item.body}`}
                                                style={{
                                                    fontSize: 11,
                                                    color: 'white',
                                                    backgroundColor: statusColor(item.status),
                                                    borderRadius: 3,
                                                    padding: '2px 4px',
                                                    marginBottom: 3,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    cursor: 'pointer'
                                                }}>
                                                {prettyTime(epochToEasternWallTime(item.scheduledAt).split('T')[1])} {item.title}
                                            </div>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div style={{ marginTop: 25, fontSize: 16, fontWeight: 'bold' }}>
                        Upcoming ({upcoming.length})
                    </div>
                    {upcoming.length === 0 && (
                        <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>Nothing scheduled yet.</div>
                    )}
                    {upcoming.map(renderRow)}

                    <div style={{ marginTop: 25, fontSize: 16, fontWeight: 'bold' }}>
                        History ({past.length})
                    </div>
                    {past.length === 0 && (
                        <div style={{ fontSize: 13, color: '#888', marginTop: 6, marginBottom: 40 }}>No notifications sent from the schedule yet.</div>
                    )}
                    {past.map(renderRow)}

                    <div style={{ height: 60 }} />
                </div>
            </div>

            {loader && (
                <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
                    <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
                        <Loader color="white" height={70} width={70} visible={true} />
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    );
};

export default ScheduledNotifications;
